import GiftSettingDialog from "./giftSettingDialog.container";

export default GiftSettingDialog;
